<template>
  <GoogleMap
    style="width: 100%; height: 600px"
    :api-key="GOOGLE_MAP_API_KEY"
    :center="center"
    :zoom="zoom"
  >
    <Marker
      v-for="event in events"
      :key="event.id"
      :options="{ position: event.coord }"
    >
      <InfoWindow
        :model-value="selected === event.id"
        @update:model-value="$emit('update:selected', $event ? event.id : null)"
      >
        <h6>{{ event.title }}</h6>
        <p>{{ event.startTime.toLocaleString() }}</p>
        <p>{{ event.address }}</p>
      </InfoWindow>
    </Marker>
  </GoogleMap>
</template>

<script lang="ts">
export type Coordinate = { lat: number; lng: number };
</script>

<script setup lang="ts">
import { GoogleMap, InfoWindow, Marker } from "vue3-google-map";
import { LiveCPDEvent } from "./EventsList.vue";

const GOOGLE_MAP_API_KEY = "AIzaSyASvZOQQzxwy8xzAcQNE2Xrr5SFj4LCFNE";

withDefaults(
  defineProps<{
    events: LiveCPDEvent[];
    selected: string | null;
    center: Coordinate;
    zoom: number;
  }>(),
  { zoom: 5 }
);
defineEmits<{
  (e: "update:selected", v: string | null): void;
}>();
</script>
